package com.example.positionahead.domain

import com.example.positionahead.model.Position
import com.example.positionahead.model.withAddedLot

object PositionMerger {

    fun mergeBySymbol(positions: List<Position>): List<Position> =
        positions.groupBy { it.symbol.uppercase() }
            .map { (_, group) ->
                val first = group.first()
                Position(
                    id = first.id,
                    symbol = first.symbol.uppercase(),
                    assetClass = first.assetClass,
                    lots = group.flatMap { it.lots },
                )
            }

    fun mergeIntoExisting(existing: List<Position>, incoming: List<Position>): List<Position> {
        val mergedIncoming = mergeBySymbol(incoming)
        val bySymbol = existing.associateBy { it.symbol.uppercase() }.toMutableMap()

        mergedIncoming.forEach { incomingPosition ->
            val key = incomingPosition.symbol.uppercase()
            val current = bySymbol[key]
            bySymbol[key] = if (current == null) {
                incomingPosition
            } else {
                current.withAddedLot(incomingPosition.lots.first()).let { updated ->
                    incomingPosition.lots.drop(1).fold(updated) { acc, lot -> acc.withAddedLot(lot) }
                }
            }
        }

        return bySymbol.values.toList()
    }
}
